var neutral = {
  100: '#FAFBFC',
  200: '#F2F5F9',
  300: '#EBEFF5',
  400: '#D7DEE8',
  500: '#BCC5D2',
  600: '#98A3B0',
  700: '#6C7682',
  800: '#3D444C',
  900: '#141619'
};
export default neutral;